import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _dec, _class, _dec2, _class2, _dec3, _class3, _dec4, _class4, _dec5, _class5, _dec6, _class6, _dec7, _class7, _dec8, _class8, _dec9, _class9, _dec10, _class10, _dec11, _class11, _dec12, _class12, _dec13, _class13, _dec14, _class14, _dec15, _class15, _dec16, _class16, _dec17, _class17, _dec18, _class18, _dec19, _class19, _dec20, _class20, _dec21, _class21, _dec22, _class22, _dec23, _class23, _dec24, _class24, _dec25, _class25, _dec26, _class26, _dec27, _class27, _dec28, _class28, _dec29, _class29, _dec30, _class30, _dec31, _class31;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable max-classes-per-file */
import { BaseCommand, DefineCommand } from '@beefco/bus';
/**
 * Служебные команды платформы
 */
export var SetPageCommand = (_dec = DefineCommand('SET_PAGE'), _dec(_class = /*#__PURE__*/function (_BaseCommand) {
  _inherits(SetPageCommand, _BaseCommand);
  var _super = _createSuper(SetPageCommand);
  function SetPageCommand() {
    _classCallCheck(this, SetPageCommand);
    return _super.apply(this, arguments);
  }
  return _createClass(SetPageCommand);
}(BaseCommand)) || _class);
export var InitPageCommand = (_dec2 = DefineCommand('INIT_PAGE'), _dec2(_class2 = /*#__PURE__*/function (_BaseCommand2) {
  _inherits(InitPageCommand, _BaseCommand2);
  var _super2 = _createSuper(InitPageCommand);
  function InitPageCommand() {
    _classCallCheck(this, InitPageCommand);
    return _super2.apply(this, arguments);
  }
  return _createClass(InitPageCommand);
}(BaseCommand)) || _class2);
export var InitLocalPageCommand = (_dec3 = DefineCommand('INIT_LOCAL_PAGE'), _dec3(_class3 = /*#__PURE__*/function (_BaseCommand3) {
  _inherits(InitLocalPageCommand, _BaseCommand3);
  var _super3 = _createSuper(InitLocalPageCommand);
  function InitLocalPageCommand() {
    _classCallCheck(this, InitLocalPageCommand);
    return _super3.apply(this, arguments);
  }
  return _createClass(InitLocalPageCommand);
}(BaseCommand)) || _class3);
export var UpdateLocalProjectCommand = (_dec4 = DefineCommand('UPDATE_LOCAL_PROJECT'), _dec4(_class4 = /*#__PURE__*/function (_BaseCommand4) {
  _inherits(UpdateLocalProjectCommand, _BaseCommand4);
  var _super4 = _createSuper(UpdateLocalProjectCommand);
  function UpdateLocalProjectCommand() {
    _classCallCheck(this, UpdateLocalProjectCommand);
    return _super4.apply(this, arguments);
  }
  return _createClass(UpdateLocalProjectCommand);
}(BaseCommand)) || _class4);
export var SetStoragePageCommand = (_dec5 = DefineCommand('SET_STORAGE_PAGE'), _dec5(_class5 = /*#__PURE__*/function (_BaseCommand5) {
  _inherits(SetStoragePageCommand, _BaseCommand5);
  var _super5 = _createSuper(SetStoragePageCommand);
  function SetStoragePageCommand() {
    _classCallCheck(this, SetStoragePageCommand);
    return _super5.apply(this, arguments);
  }
  return _createClass(SetStoragePageCommand);
}(BaseCommand)) || _class5);
export var InitStoragePageCommand = (_dec6 = DefineCommand('INIT_STORAGE_PAGE'), _dec6(_class6 = /*#__PURE__*/function (_BaseCommand6) {
  _inherits(InitStoragePageCommand, _BaseCommand6);
  var _super6 = _createSuper(InitStoragePageCommand);
  function InitStoragePageCommand() {
    _classCallCheck(this, InitStoragePageCommand);
    return _super6.apply(this, arguments);
  }
  return _createClass(InitStoragePageCommand);
}(BaseCommand)) || _class6);
export var InitLocalProjectCommand = (_dec7 = DefineCommand('INIT_LOCAL_PROJECT'), _dec7(_class7 = /*#__PURE__*/function (_BaseCommand7) {
  _inherits(InitLocalProjectCommand, _BaseCommand7);
  var _super7 = _createSuper(InitLocalProjectCommand);
  function InitLocalProjectCommand() {
    _classCallCheck(this, InitLocalProjectCommand);
    return _super7.apply(this, arguments);
  }
  return _createClass(InitLocalProjectCommand);
}(BaseCommand)) || _class7);

/** Используется для создания в проекте страницы */
export var CreateLocalPageCommand = (_dec8 = DefineCommand('CREATE_LOCAL_PAGE'), _dec8(_class8 = /*#__PURE__*/function (_BaseCommand8) {
  _inherits(CreateLocalPageCommand, _BaseCommand8);
  var _super8 = _createSuper(CreateLocalPageCommand);
  function CreateLocalPageCommand() {
    _classCallCheck(this, CreateLocalPageCommand);
    return _super8.apply(this, arguments);
  }
  return _createClass(CreateLocalPageCommand);
}(BaseCommand)) || _class8);
export var SynchronizeStateCommand = (_dec9 = DefineCommand('SYNCHRONIZE_STATE'), _dec9(_class9 = /*#__PURE__*/function (_BaseCommand9) {
  _inherits(SynchronizeStateCommand, _BaseCommand9);
  var _super9 = _createSuper(SynchronizeStateCommand);
  function SynchronizeStateCommand() {
    _classCallCheck(this, SynchronizeStateCommand);
    return _super9.apply(this, arguments);
  }
  return _createClass(SynchronizeStateCommand);
}(BaseCommand)) || _class9);

// FIXME: Надо вспомнить зачем оно вообще нужно было
export var RequestLibraryCommand = (_dec10 = DefineCommand('REQUEST_LIBRARY'), _dec10(_class10 = /*#__PURE__*/function (_BaseCommand10) {
  _inherits(RequestLibraryCommand, _BaseCommand10);
  var _super10 = _createSuper(RequestLibraryCommand);
  function RequestLibraryCommand() {
    _classCallCheck(this, RequestLibraryCommand);
    return _super10.apply(this, arguments);
  }
  return _createClass(RequestLibraryCommand);
}(BaseCommand)) || _class10);
export var InitDevServerCommand = (_dec11 = DefineCommand('INIT_DEV_SERVER'), _dec11(_class11 = /*#__PURE__*/function (_BaseCommand11) {
  _inherits(InitDevServerCommand, _BaseCommand11);
  var _super11 = _createSuper(InitDevServerCommand);
  function InitDevServerCommand() {
    _classCallCheck(this, InitDevServerCommand);
    return _super11.apply(this, arguments);
  }
  return _createClass(InitDevServerCommand);
}(BaseCommand)) || _class11);
/**
 * Браузерные generic-события
 */
export var SelectionSelectNodeCommand = (_dec12 = DefineCommand('SELECTION_SELECT'), _dec12(_class12 = /*#__PURE__*/function (_BaseCommand12) {
  _inherits(SelectionSelectNodeCommand, _BaseCommand12);
  var _super12 = _createSuper(SelectionSelectNodeCommand);
  function SelectionSelectNodeCommand() {
    _classCallCheck(this, SelectionSelectNodeCommand);
    return _super12.apply(this, arguments);
  }
  return _createClass(SelectionSelectNodeCommand);
}(BaseCommand)) || _class12);
export var SelectionHoverNodeCommand = (_dec13 = DefineCommand('SELECTION_HOVER'), _dec13(_class13 = /*#__PURE__*/function (_BaseCommand13) {
  _inherits(SelectionHoverNodeCommand, _BaseCommand13);
  var _super13 = _createSuper(SelectionHoverNodeCommand);
  function SelectionHoverNodeCommand() {
    _classCallCheck(this, SelectionHoverNodeCommand);
    return _super13.apply(this, arguments);
  }
  return _createClass(SelectionHoverNodeCommand);
}(BaseCommand)) || _class13);
export var UpdateObservedIdsCommand = (_dec14 = DefineCommand('UPDATE_OBSERVED_IDS'), _dec14(_class14 = /*#__PURE__*/function (_BaseCommand14) {
  _inherits(UpdateObservedIdsCommand, _BaseCommand14);
  var _super14 = _createSuper(UpdateObservedIdsCommand);
  function UpdateObservedIdsCommand() {
    _classCallCheck(this, UpdateObservedIdsCommand);
    return _super14.apply(this, arguments);
  }
  return _createClass(UpdateObservedIdsCommand);
}(BaseCommand)) || _class14);
export var SetNodeRectsCommand = (_dec15 = DefineCommand('SET_NODE_RECTS'), _dec15(_class15 = /*#__PURE__*/function (_BaseCommand15) {
  _inherits(SetNodeRectsCommand, _BaseCommand15);
  var _super15 = _createSuper(SetNodeRectsCommand);
  function SetNodeRectsCommand() {
    _classCallCheck(this, SetNodeRectsCommand);
    return _super15.apply(this, arguments);
  }
  return _createClass(SetNodeRectsCommand);
}(BaseCommand)) || _class15);
export var UpdateNodeRectsCommand = (_dec16 = DefineCommand('UPDATE_NODE_RECTS'), _dec16(_class16 = /*#__PURE__*/function (_BaseCommand16) {
  _inherits(UpdateNodeRectsCommand, _BaseCommand16);
  var _super16 = _createSuper(UpdateNodeRectsCommand);
  function UpdateNodeRectsCommand() {
    _classCallCheck(this, UpdateNodeRectsCommand);
    return _super16.apply(this, arguments);
  }
  return _createClass(UpdateNodeRectsCommand);
}(BaseCommand)) || _class16);
export var ForwardNativeMouseEventCommand = (_dec17 = DefineCommand('FORWARD_NATIVE_MOUSE_EVENT'), _dec17(_class17 = /*#__PURE__*/function (_BaseCommand17) {
  _inherits(ForwardNativeMouseEventCommand, _BaseCommand17);
  var _super17 = _createSuper(ForwardNativeMouseEventCommand);
  function ForwardNativeMouseEventCommand() {
    _classCallCheck(this, ForwardNativeMouseEventCommand);
    return _super17.apply(this, arguments);
  }
  return _createClass(ForwardNativeMouseEventCommand);
}(BaseCommand)) || _class17);
export var ForwardNativeKeyboardEventCommand = (_dec18 = DefineCommand('FORWARD_NATIVE_KEYBOARD_EVENT'), _dec18(_class18 = /*#__PURE__*/function (_BaseCommand18) {
  _inherits(ForwardNativeKeyboardEventCommand, _BaseCommand18);
  var _super18 = _createSuper(ForwardNativeKeyboardEventCommand);
  function ForwardNativeKeyboardEventCommand() {
    _classCallCheck(this, ForwardNativeKeyboardEventCommand);
    return _super18.apply(this, arguments);
  }
  return _createClass(ForwardNativeKeyboardEventCommand);
}(BaseCommand)) || _class18);
export var ForwardedWheelEventCommand = (_dec19 = DefineCommand('FORWARD_NATIVE_WHEEL_EVENT'), _dec19(_class19 = /*#__PURE__*/function (_BaseCommand19) {
  _inherits(ForwardedWheelEventCommand, _BaseCommand19);
  var _super19 = _createSuper(ForwardedWheelEventCommand);
  function ForwardedWheelEventCommand() {
    _classCallCheck(this, ForwardedWheelEventCommand);
    return _super19.apply(this, arguments);
  }
  return _createClass(ForwardedWheelEventCommand);
}(BaseCommand)) || _class19);

/**
 * Браузерные DND-события
 */
export var ComponentDragStartCommand = (_dec20 = DefineCommand('COMPONENT_DRAG_START'), _dec20(_class20 = /*#__PURE__*/function (_BaseCommand20) {
  _inherits(ComponentDragStartCommand, _BaseCommand20);
  var _super20 = _createSuper(ComponentDragStartCommand);
  function ComponentDragStartCommand() {
    _classCallCheck(this, ComponentDragStartCommand);
    return _super20.apply(this, arguments);
  }
  return _createClass(ComponentDragStartCommand);
}(BaseCommand)) || _class20);
export var ResetDragTargetCommand = (_dec21 = DefineCommand('NODE_DRAG_RESET_TARGET'), _dec21(_class21 = /*#__PURE__*/function (_BaseCommand21) {
  _inherits(ResetDragTargetCommand, _BaseCommand21);
  var _super21 = _createSuper(ResetDragTargetCommand);
  function ResetDragTargetCommand() {
    _classCallCheck(this, ResetDragTargetCommand);
    return _super21.apply(this, arguments);
  }
  return _createClass(ResetDragTargetCommand);
}(BaseCommand)) || _class21);
export var SetDragTargetCommand = (_dec22 = DefineCommand('DRAG_SET_TARGET'), _dec22(_class22 = /*#__PURE__*/function (_BaseCommand22) {
  _inherits(SetDragTargetCommand, _BaseCommand22);
  var _super22 = _createSuper(SetDragTargetCommand);
  function SetDragTargetCommand() {
    _classCallCheck(this, SetDragTargetCommand);
    return _super22.apply(this, arguments);
  }
  return _createClass(SetDragTargetCommand);
}(BaseCommand)) || _class22);
export var NodeDragStartCommand = (_dec23 = DefineCommand('NODE_DRAG_START'), _dec23(_class23 = /*#__PURE__*/function (_BaseCommand23) {
  _inherits(NodeDragStartCommand, _BaseCommand23);
  var _super23 = _createSuper(NodeDragStartCommand);
  function NodeDragStartCommand() {
    _classCallCheck(this, NodeDragStartCommand);
    return _super23.apply(this, arguments);
  }
  return _createClass(NodeDragStartCommand);
}(BaseCommand)) || _class23);
export var EntityDragDropCommand = (_dec24 = DefineCommand('DRAG_DROP'), _dec24(_class24 = /*#__PURE__*/function (_BaseCommand24) {
  _inherits(EntityDragDropCommand, _BaseCommand24);
  var _super24 = _createSuper(EntityDragDropCommand);
  function EntityDragDropCommand() {
    _classCallCheck(this, EntityDragDropCommand);
    return _super24.apply(this, arguments);
  }
  return _createClass(EntityDragDropCommand);
}(BaseCommand)) || _class24);
export var EntityDragMouseDownCommand = (_dec25 = DefineCommand('DRAG_MOUSE_DOWN'), _dec25(_class25 = /*#__PURE__*/function (_BaseCommand25) {
  _inherits(EntityDragMouseDownCommand, _BaseCommand25);
  var _super25 = _createSuper(EntityDragMouseDownCommand);
  function EntityDragMouseDownCommand() {
    _classCallCheck(this, EntityDragMouseDownCommand);
    return _super25.apply(this, arguments);
  }
  return _createClass(EntityDragMouseDownCommand);
}(BaseCommand)) || _class25);
export var EntityDragMouseUpCommand = (_dec26 = DefineCommand('DRAG_MOUSE_UP'), _dec26(_class26 = /*#__PURE__*/function (_BaseCommand26) {
  _inherits(EntityDragMouseUpCommand, _BaseCommand26);
  var _super26 = _createSuper(EntityDragMouseUpCommand);
  function EntityDragMouseUpCommand() {
    _classCallCheck(this, EntityDragMouseUpCommand);
    return _super26.apply(this, arguments);
  }
  return _createClass(EntityDragMouseUpCommand);
}(BaseCommand)) || _class26);
export var NodeDragDropCommand = (_dec27 = DefineCommand('NODE_DROP'), _dec27(_class27 = /*#__PURE__*/function (_BaseCommand27) {
  _inherits(NodeDragDropCommand, _BaseCommand27);
  var _super27 = _createSuper(NodeDragDropCommand);
  function NodeDragDropCommand() {
    _classCallCheck(this, NodeDragDropCommand);
    return _super27.apply(this, arguments);
  }
  return _createClass(NodeDragDropCommand);
}(BaseCommand)) || _class27);
export var ComponentDragDropCommand = (_dec28 = DefineCommand('COMPONENT_DROP'), _dec28(_class28 = /*#__PURE__*/function (_BaseCommand28) {
  _inherits(ComponentDragDropCommand, _BaseCommand28);
  var _super28 = _createSuper(ComponentDragDropCommand);
  function ComponentDragDropCommand() {
    _classCallCheck(this, ComponentDragDropCommand);
    return _super28.apply(this, arguments);
  }
  return _createClass(ComponentDragDropCommand);
}(BaseCommand)) || _class28);
export var CommonDragEndCommand = (_dec29 = DefineCommand('DRAG_END'), _dec29(_class29 = /*#__PURE__*/function (_BaseCommand29) {
  _inherits(CommonDragEndCommand, _BaseCommand29);
  var _super29 = _createSuper(CommonDragEndCommand);
  function CommonDragEndCommand() {
    _classCallCheck(this, CommonDragEndCommand);
    return _super29.apply(this, arguments);
  }
  return _createClass(CommonDragEndCommand);
}(BaseCommand)) || _class29);
export var SidebarDragOverEnterCommand = (_dec30 = DefineCommand('SIDEBAR_DRAG'), _dec30(_class30 = /*#__PURE__*/function (_BaseCommand30) {
  _inherits(SidebarDragOverEnterCommand, _BaseCommand30);
  var _super30 = _createSuper(SidebarDragOverEnterCommand);
  function SidebarDragOverEnterCommand() {
    _classCallCheck(this, SidebarDragOverEnterCommand);
    return _super30.apply(this, arguments);
  }
  return _createClass(SidebarDragOverEnterCommand);
}(BaseCommand)) || _class30);
export var SidebarDragDropCommand = (_dec31 = DefineCommand('SIDEBAR_DRAG_DROP'), _dec31(_class31 = /*#__PURE__*/function (_BaseCommand31) {
  _inherits(SidebarDragDropCommand, _BaseCommand31);
  var _super31 = _createSuper(SidebarDragDropCommand);
  function SidebarDragDropCommand() {
    _classCallCheck(this, SidebarDragDropCommand);
    return _super31.apply(this, arguments);
  }
  return _createClass(SidebarDragDropCommand);
}(BaseCommand)) || _class31);